<template>
  <div class="body">
    <NavbarStart></NavbarStart>
    <section class="hero">
      <div class="container">
        <div class="columns flex">
          <div class="column is-5">
            <h1 class="title">Words from the team</h1>
            <p>
              The journey of KEEP started in the end of 2017, when a group from Chalmers Industriteknik together with 7 organisations applied for a pre-study to explore how traceability could support circular economy for electrical and electronic products. The pre-study was granted funding by the Swedish Innovation Agency Vinnova, and became KEEP phase 1. During 2018, talks were held with different companies and organisations along the value chain of electronic products about how traceability could support them in, for example, prolonging longevity of products and making material recycling more efficient. Back then, people were often sceptical to the chances to implement traceability systems.
            </p>
          </div>
          <div class="column is-1"></div>
          <div class="column">
            <div class="hero-img">
              <img
                src="@/assets/Recycler2.png"
                alt="hero-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-blue">
      <div class="container">
        <div class="columns flex">
          <div class="column">
            <div class="why-img">
              <img src="@/assets/illustrations/onboarding/Producer3.png" alt="" />
            </div>
          </div>
          <div class="column is-1"></div>
          <div class="column is-5">
            <p>
              Despite some scepticism, we applied and got funding for KEEP phase 2, which started in spring 2019. The project had grown and now gathered 14 organisations who also saw potential and wanted to explore a possible traceability solution. During the two years of KEEP phase 2 the interest in traceability systems skyrocketed, much thanks to the discussions in the EU commission about digital product passports and their mentioning in The European Green Deal.
            </p>
            <p>
              In the spring of 2021, the strategic innovation program PiiA (Process industrial automation) together with 4 other strategic innovation programs, wanted to finance an umbrella project about traceability. This was a great opportunity as KEEP phase 2 was coming to an end and we were eager to continue our work on traceability.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white">
      <div class="container">
        <div class="columns flex">
          <div class="column is-6">
            <p>
              This umbrella project became Trace4Value which brings roughly 70 partners together, where KEEP's third and final phase is 1 of 5 projects financed by Vinnova through the program Sustainable Industry. KEEP phase 3 is a consortium of 23 partners and the main focus of the project has been testing parts of a full traceability system.
            </p>
            <p>
              If we thought the interest in traceability and the digital product passports was big in 2021, we had no idea how big it would be a few years later! The EU commission has the long-term goal to implement a digital product passport for every product sold in Europe. Late in 2023, the final draft of the Ecodesign for Sustainable Products Regulation (ESPR) was published, outlining the general requirements for a digital product pass. The first product category, the batteries, is expected to be implemented at the latest in February 2027.
            </p>
          </div>
          <div class="column">
            <div class="why-img">
              <img src="@/assets/illustrations/producer2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-light-blue">
      <div class="container">
        <div class="columns flex">
          <div class="column">
            <div class="hero-img">
              <img
                src="@/assets/illustrations/onboarding/Certifier1.png"
                alt="hero-img"
              />
            </div>
          </div>
          <div class="column is-1"></div>
          <div class="column is-5">
            <p>
              There is strength in having such a diverse consortium, allowing us to gather a broad range of perspectives. We are very proud and grateful to have had the chance to lead the work of such a competent group of very interested people. We hope the learnings from this project will be the seed of other joint ventures and innovation projects.
            </p>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import NavbarStart from "@/components/NavbarStart.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Team",
  components: {
    NavbarStart,
    Footer
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/global.scss";
section {
  padding: 4rem 0;

  @media screen and (max-width: $mobileMenuBreakpoint) {
    padding: 2rem 0;
  }
}

div.container {
  margin-top: 4rem;
  margin-bottom: 4rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  @media screen and (max-width: $mobileMenuBreakpoint) {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
</style>
